/** Tailwind class tokens — aligned with landing page (indigo #4f46e5, slate palette) */

export const dash = {
  shell: 'min-h-screen bg-slate-950 text-slate-100 overflow-x-hidden',
  shellRow: 'flex h-screen overflow-hidden',
  sidebar:
    'w-64 shrink-0 bg-slate-900/95 border-r border-slate-800/80 backdrop-blur-xl h-screen overflow-y-auto',
  sidebarMobile:
    'fixed inset-y-0 left-0 z-50 w-72 bg-slate-900 border-r border-slate-800 shadow-2xl h-screen overflow-y-auto',
  main: 'flex-1 min-w-0 flex flex-col h-screen overflow-hidden',
  mainScroll: 'flex-1 min-w-0 overflow-y-auto overflow-x-hidden',
  mainInner: 'w-full max-w-7xl mx-auto box-border px-4 sm:px-5 lg:px-6 py-5 lg:py-6',
  topBar:
    'shrink-0 box-border px-4 sm:px-5 lg:px-6 py-3 bg-slate-950/90 backdrop-blur-md border-b border-slate-800/60',
  page: 'w-full min-w-0 space-y-5 lg:space-y-6',
  gridStats: 'grid w-full min-w-0 grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 sm:gap-4',
  grid2: 'grid w-full min-w-0 grid-cols-1 xl:grid-cols-2 gap-4 lg:gap-5 items-stretch',
  grid3: 'grid w-full min-w-0 grid-cols-1 xl:grid-cols-3 gap-4 lg:gap-5 items-stretch',
  card: 'bg-slate-900/70 rounded-2xl border border-slate-800/80 shadow-sm min-w-0 w-full box-border',
  cardPad: 'p-4 sm:p-5',
  cardHover: 'hover:border-indigo-500/30 transition-colors',
  nested: 'bg-slate-950/60 rounded-xl border border-slate-800/70 min-w-0',
  input:
    'w-full min-w-0 bg-slate-950/80 border border-slate-700 rounded-xl px-4 py-3 text-slate-100 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500/50 transition-shadow box-border',
  label: 'block text-sm font-medium text-slate-300 mb-2',
  btnPrimary:
    'inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold rounded-xl transition-all shadow-sm hover:shadow-indigo-500/25 disabled:opacity-50 disabled:cursor-not-allowed shrink-0',
  btnSecondary:
    'inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-slate-800 hover:bg-slate-700 text-slate-200 font-medium rounded-xl border border-slate-700 transition-colors shrink-0',
  btnGhost:
    'inline-flex items-center gap-1.5 text-sm text-indigo-400 hover:text-indigo-300 font-medium transition-colors shrink-0',
  btnDanger:
    'inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-red-600/90 hover:bg-red-600 text-white font-medium rounded-xl transition-colors shrink-0',
  navActive: 'bg-indigo-600 text-white shadow-md shadow-indigo-600/20',
  navIdle: 'text-slate-400 hover:bg-slate-800/80 hover:text-slate-200',
  iconBox: 'w-10 h-10 shrink-0 rounded-xl bg-gradient-to-br from-indigo-600 to-violet-600 flex items-center justify-center shadow-lg shadow-indigo-600/20',
  overline: 'text-[0.7rem] font-bold uppercase tracking-[0.12em] text-indigo-400',
  heroGradient: 'bg-gradient-to-br from-indigo-600/15 via-violet-600/10 to-slate-900/80',
  pricingHighlight: 'ring-2 ring-indigo-500/50 shadow-lg shadow-indigo-500/10',
  pricingCard: 'bg-slate-900/80 rounded-2xl border border-slate-800/80 p-5 sm:p-6 flex flex-col h-full min-w-0',
  stepActive: 'bg-indigo-600 text-white ring-4 ring-indigo-600/25',
  stepDone: 'bg-emerald-600/20 text-emerald-400 ring-2 ring-emerald-500/30',
  stepIdle: 'bg-slate-800 text-slate-500',
};

export function cn(...parts) {
  return parts.filter(Boolean).join(' ');
}